import React from 'react';
import _ from 'lodash';

function onDragStart1(Transition, e) {
  e.preventDefault();
}

function repeatItem2(Transition, item, itemIndex) {
  return /*#__PURE__*/React.createElement("div", {
    key: item.key,
    onMouseDown: this.onMouseDown.bind(this, itemIndex)
  }, item);
}

function repeatItem3(Transition, item, itemIndex) {
  return /*#__PURE__*/React.createElement("div", {
    key: item.key,
    onMouseDown: this.onMouseDown.bind(this, itemIndex)
  }, item);
}

function scopeTransition4() {
  var Transition = this.getTransitionClass();
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.className,
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook,
    onDragStart: onDragStart1.bind(this, Transition)
  }, React.createElement.apply(this, ['div', {
    style: {
      position: 'relative'
    }
  }, this.props.childrenTransition ? React.createElement.apply(this, [Transition, _.assign({}, {
    key: 'da-transition'
  }, this.props.transitionProps), _.map(this.getItems(), repeatItem2.bind(this, Transition))]) : null, this.props.childrenTransition ? null : _.map(this.getItems(), repeatItem3.bind(this, Transition))]));
}

export default function () {
  return scopeTransition4.apply(this, []);
}